import type { Resource } from '../../';
export const header_endlessAislePOSBanner_message: Resource = {"default":"Infinite POS Enabled - Store: {storeId}"};
